const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/stories/index.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_app/stories/")({
  loader: lazyFn($$splitLoaderImporter, 'loader')
});